import React from "react"
import Icon from "src/shared/icons"
import { COLLECTION } from "src/shared/icons/Icon"

import "./RoomCardHeaderUI.css"
import { useDate } from "src/shared/hooks/useDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useModulos } from "src/shared/hooks/useModulos"
import useMinuteTimer from "src/shared/hooks/useMinuteTimer"
import { formatTime } from "src/shared/utils/formatTime"

const RoomCardHeaderUI = ({
    iconName,
    iconBgColor,
    iconBgSecondaryColor,
    roomTypeName,
    roomNumber,
    description,
    roomServiceTimeEnd = "",
    isExtraTime = false,
    hasIncidences,
    alertTimerBgColor1,
    alertTimerBgColor2,
    alertTimerTextColor1,
    alertTimerTextColor2,
    easyrewards,
    orderTimer,
    orderTimerTimeout = false,
    timeout,
}: {
    iconName: keyof typeof COLLECTION | (string & {})
    iconBgColor: string
    iconBgSecondaryColor?: string
    roomTypeName: string
    roomNumber: string
    description?: string
    hasIncidences?: boolean
    roomServiceTimeEnd?: string
    roomServiceTimeStart?: string
    isExtraTime?: boolean
    // Estos son opcionales dado que solo se muestran en el caso de roomService
    alertTimerBgColor1?: string
    alertTimerBgColor2?: string
    alertTimerTextColor1?: string
    alertTimerTextColor2?: string
    easyrewards?: string
    orderTimer?: string
    // Indica si el orderTimer ya superó el umbral (ej. 25min sin entregar) y debe verse en rojo
    orderTimerTimeout?: boolean
    // Cuando se especifica, controla el estilo del timer sin importar la fecha (ej. umbral de 20min de pago pendiente)
    timeout?: boolean
}) => {
    const [now] = useTimePulse()
    const { UTCStringToLocalDate } = useDate()

    const { timeValue: roomServiceTimer } = useMinuteTimer({ timeStartUTC: roomServiceTimeEnd, withHours: true })

    const isTimeout = typeof timeout === "boolean" ? timeout : now > UTCStringToLocalDate(roomServiceTimeEnd)

    const { easyRewards: withEasyrewards } = useModulos()

    return (
        <div>
            <div className="room-card--xl-header">
                <div className="room-card--xl-header__left__wrapper">
                    <div className="room-card--xl-header__icon--wrapper" style={{ backgroundColor: iconBgColor }}>
                        <Icon
                            name={iconName}
                            color="var(--white)"
                            width={23}
                            height={23}
                            secondarycolor={iconBgSecondaryColor}
                        />
                    </div>
                    {!!orderTimer && (
                        <span
                            className={
                                orderTimerTimeout
                                    ? "room-card--xl-header__timer--timeout"
                                    : "room-card--xl-header__timer"
                            }
                        >
                            {orderTimer}
                        </span>
                    )}
                    {!!roomServiceTimeEnd && (
                        <span
                            className={
                                isTimeout ? "room-card--xl-header__timer--timeout" : "room-card--xl-header__timer"
                            }
                        >
                            {formatTime({ time: roomServiceTimer, withHours: true })}
                        </span>
                    )}
                </div>
                {isExtraTime && !roomServiceTimeEnd && (
                    <span className="room-card--xl-header__description">{description}</span>
                )}
                <div className="room-card--xl-header__name--wrapper">
                    <span className="room-card--xl-header__type-name">
                        {easyrewards && withEasyrewards && (
                            <div className="room-card--xl-header__gift-icon">
                                <Icon name="giftFill" width={14} height={14} color="var(--purple-drawer-primario)" />
                            </div>
                        )}
                        {roomTypeName}
                    </span>
                    <span className="room-card--xl-header__number">
                        {!!hasIncidences && (
                            <Icon
                                name="alertFill"
                                color="var(--orange-warning)"
                                width={21}
                                height={21}
                                style={{ marginRight: "3px" }}
                            />
                        )}
                        {roomNumber}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default RoomCardHeaderUI
